unit View.Grupos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewGruposEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientGruposGet: TXDataWebClient;
    XDataClientGruposDelete: TXDataWebClient;
    GruposDataset: TXDataWebDataSet;
    GruposDatasetid: TIntegerField;
    GruposDatasetaliado_id: TIntegerField;
    GruposDatasetdata_base_id: TIntegerField;
    GruposDatasetnome: TStringField;
    GruposDatasetcodigo_interno: TIntegerField;
    GruposDatasetexcluido: TBooleanField;
    GruposDatasetinclusao: TDateTimeField;
    GruposDatasetalteracao: TDateTimeField;
    GruposDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientGruposGetLoad(Response: TXDataClientResponse);
    procedure XDataClientGruposDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientGruposDeleteError(Error: TXDataClientError);
    procedure GruposDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewGruposEdit: TFViewGruposEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewGruposEdit }

procedure TFViewGruposEdit.btSaveClick(Sender: TObject);
begin
  if GruposDataset.State in dsEditModes then
  begin
        GruposDataset.Post;
    GruposDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewGruposEdit.btDeleteClick(Sender: TObject);
begin
  if GruposDataset.State in dsEditModes then
    GruposDataset.Post;
  XDataClientGruposDelete.Delete(GruposDataset.EntitySetName,
    TJSObject(GruposDataset.CurrentData));
end;


class function TFViewGruposEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewGruposEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewGruposEdit.InsertEntity;
begin
  GruposDataset.Close;
  GruposDataset.SetJsonData('{}');
  GruposDataset.Open;
  GruposDataset.Insert;
end;

class function TFViewGruposEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewGruposEdit(AForm).FInserting := AInserting;
    TFViewGruposEdit(AForm).FId := AId;
    TFViewGruposEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewGruposEdit(AForm).InsertEntity
    else
      TFViewGruposEdit(AForm).LoadEntity;
    TFViewGruposEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewGruposEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewGruposEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    GruposDataset.Connection.Model.DefaultSchema.FindEntityType(
      GruposDataset.EntitySetName
    )
  );
  XDataClientGruposGet.Get(GruposDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewGruposEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewGruposEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewGruposEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewGruposEdit.XDataClientGruposGetLoad(Response: TXDataClientResponse);
begin
  GruposDataset.Close;
  GruposDataset.SetJsonData(Response.Result);
  GruposDataset.Open;
  
  GruposDataset.Edit;  
end;

procedure TFViewGruposEdit.XDataClientGruposDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewGruposEdit.XDataClientGruposDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewGruposEdit.GruposDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewGruposEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewGruposEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.grupos.form.message');
  lbMessage := TLabel.Create('view.grupos.form.message.label');
  btCloseMessage := TButton.Create('view.grupos.form.message.button');
  btCancel := TButton.Create('view.grupos.form.btBack');
  btSave := TButton.Create('view.grupos.form.btSave');
  btDelete := TButton.Create('view.grupos.form.btDelete');
  lbid := TLabel.Create('view.grupos.form.lbid');
  edid := TDBEdit.Create('view.grupos.form.edid');
  lbaliado_id := TLabel.Create('view.grupos.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.grupos.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.grupos.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.grupos.form.eddata_base_id');
  lbnome := TLabel.Create('view.grupos.form.lbnome');
  ednome := TDBEdit.Create('view.grupos.form.ednome');
  lbcodigo_interno := TLabel.Create('view.grupos.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.grupos.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.grupos.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.grupos.form.edexcluido');
  lbinclusao := TLabel.Create('view.grupos.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.grupos.form.edinclusao');
  lbalteracao := TLabel.Create('view.grupos.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.grupos.form.edalteracao');
  lbexclusao := TLabel.Create('view.grupos.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.grupos.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  GruposDataset := TXDataWebDataSet.Create(Self);
  GruposDatasetid := TIntegerField.Create(Self);
  GruposDatasetaliado_id := TIntegerField.Create(Self);
  GruposDatasetdata_base_id := TIntegerField.Create(Self);
  GruposDatasetnome := TStringField.Create(Self);
  GruposDatasetcodigo_interno := TIntegerField.Create(Self);
  GruposDatasetexcluido := TBooleanField.Create(Self);
  GruposDatasetinclusao := TDateTimeField.Create(Self);
  GruposDatasetalteracao := TDateTimeField.Create(Self);
  GruposDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientGruposGet := TXDataWebClient.Create(Self);
  XDataClientGruposDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  GruposDataset.BeforeLoadDFMValues;
  GruposDatasetid.BeforeLoadDFMValues;
  GruposDatasetaliado_id.BeforeLoadDFMValues;
  GruposDatasetdata_base_id.BeforeLoadDFMValues;
  GruposDatasetnome.BeforeLoadDFMValues;
  GruposDatasetcodigo_interno.BeforeLoadDFMValues;
  GruposDatasetexcluido.BeforeLoadDFMValues;
  GruposDatasetinclusao.BeforeLoadDFMValues;
  GruposDatasetalteracao.BeforeLoadDFMValues;
  GruposDatasetexclusao.BeforeLoadDFMValues;
  XDataClientGruposGet.BeforeLoadDFMValues;
  XDataClientGruposDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewGruposEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 508;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 448;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 448;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 448;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 273;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 270;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 300;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 297;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 10;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 327;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 324;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 11;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 354;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 351;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 12;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 381;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 378;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 13;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 408;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 405;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 14;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := GruposDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    GruposDataset.SetParentComponent(Self);
    GruposDataset.Name := 'GruposDataset';
    GruposDataset.AfterApplyUpdates := GruposDatasetAfterApplyUpdates;
    GruposDataset.EntitySetName := 'Grupos';
    GruposDataset.Connection := DMConnection.ApiConnection;
    GruposDataset.Left := 176;
    GruposDataset.Top := 8;
    GruposDatasetid.SetParentComponent(GruposDataset);
    GruposDatasetid.Name := 'GruposDatasetid';
    GruposDatasetid.FieldName := 'id';
    GruposDatasetid.Required := True;
    GruposDatasetaliado_id.SetParentComponent(GruposDataset);
    GruposDatasetaliado_id.Name := 'GruposDatasetaliado_id';
    GruposDatasetaliado_id.FieldName := 'aliado_id';
    GruposDatasetaliado_id.Required := True;
    GruposDatasetdata_base_id.SetParentComponent(GruposDataset);
    GruposDatasetdata_base_id.Name := 'GruposDatasetdata_base_id';
    GruposDatasetdata_base_id.FieldName := 'data_base_id';
    GruposDatasetdata_base_id.Required := True;
    GruposDatasetnome.SetParentComponent(GruposDataset);
    GruposDatasetnome.Name := 'GruposDatasetnome';
    GruposDatasetnome.FieldName := 'nome';
    GruposDatasetnome.Required := True;
    GruposDatasetnome.Size := 255;
    GruposDatasetcodigo_interno.SetParentComponent(GruposDataset);
    GruposDatasetcodigo_interno.Name := 'GruposDatasetcodigo_interno';
    GruposDatasetcodigo_interno.FieldName := 'codigo_interno';
    GruposDatasetcodigo_interno.Required := True;
    GruposDatasetexcluido.SetParentComponent(GruposDataset);
    GruposDatasetexcluido.Name := 'GruposDatasetexcluido';
    GruposDatasetexcluido.FieldName := 'excluido';
    GruposDatasetexcluido.Required := False;
    GruposDatasetinclusao.SetParentComponent(GruposDataset);
    GruposDatasetinclusao.Name := 'GruposDatasetinclusao';
    GruposDatasetinclusao.FieldName := 'inclusao';
    GruposDatasetinclusao.Required := False;
    GruposDatasetalteracao.SetParentComponent(GruposDataset);
    GruposDatasetalteracao.Name := 'GruposDatasetalteracao';
    GruposDatasetalteracao.FieldName := 'alteracao';
    GruposDatasetalteracao.Required := False;
    GruposDatasetexclusao.SetParentComponent(GruposDataset);
    GruposDatasetexclusao.Name := 'GruposDatasetexclusao';
    GruposDatasetexclusao.FieldName := 'exclusao';
    GruposDatasetexclusao.Required := False;
    XDataClientGruposGet.SetParentComponent(Self);
    XDataClientGruposGet.Name := 'XDataClientGruposGet';
    XDataClientGruposGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientGruposGet, Self, 'OnLoad', 'XDataClientGruposGetLoad');
    XDataClientGruposGet.Left := 64;
    XDataClientGruposGet.Top := 8;
    XDataClientGruposDelete.SetParentComponent(Self);
    XDataClientGruposDelete.Name := 'XDataClientGruposDelete';
    XDataClientGruposDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientGruposDelete, Self, 'OnLoad', 'XDataClientGruposDeleteLoad');
    SetEvent(XDataClientGruposDelete, Self, 'OnError', 'XDataClientGruposDeleteError');
    XDataClientGruposDelete.Left := 64;
    XDataClientGruposDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    GruposDataset.AfterLoadDFMValues;
    GruposDatasetid.AfterLoadDFMValues;
    GruposDatasetaliado_id.AfterLoadDFMValues;
    GruposDatasetdata_base_id.AfterLoadDFMValues;
    GruposDatasetnome.AfterLoadDFMValues;
    GruposDatasetcodigo_interno.AfterLoadDFMValues;
    GruposDatasetexcluido.AfterLoadDFMValues;
    GruposDatasetinclusao.AfterLoadDFMValues;
    GruposDatasetalteracao.AfterLoadDFMValues;
    GruposDatasetexclusao.AfterLoadDFMValues;
    XDataClientGruposGet.AfterLoadDFMValues;
    XDataClientGruposDelete.AfterLoadDFMValues;
  end;
end;

end.
